var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBackModalMsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "17px",
    viewBox: "0 0 10 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBackModalMsg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---quick-msg---edit-template",
    transform: "translate(-451.000000, -226.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(433.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/arrow-left",
    transform: "translate(18.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36036781,8.5035935 L9.72820381,2.14365854 C9.9035428,1.96895935 10,1.73538211 10,1.4863252 C10,1.23713008 9.9035428,1.00369106 9.72820381,0.828715447 L9.17021896,0.271723577 C8.99515675,0.0964715447 8.76114079,0 8.51176363,0 C8.26238647,0 8.02864729,0.0964715447 7.85344669,0.271723577 L0.27152312,7.84377236 C0.095630575,8.01930081 -0.000688237868,8.25384553 3.70762665e-06,8.50317886 C-0.000688237868,8.75361789 0.0954921859,8.98788618 0.27152312,9.16355285 L7.84638884,16.7282764 C8.02158944,16.9035285 8.25532863,17 8.50484417,17 C8.75422133,17 8.98796052,16.9035285 9.16329951,16.7282764 L9.72114597,16.1712846 C10.0841406,15.8087561 10.0841406,15.2185935 9.72114597,14.8562033 L3.36036781,8.5035935 Z",
    id: "icBackModalMsg"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackModalMsg);
export default __webpack_public_path__ + "static/media/icBackModalMsg.7abd5b9e1c4db8922dfe07287c19d2a3.svg";
export { ForwardRef as ReactComponent };